import { IHistoryStep, ILanding, ILandingSection } from "src/modules/pe-landing-module/data/interfaces";
import { useLandingStore } from "src/modules/pe-landing-module/data/store";
import updateHistory from "./updateHistory";
import updateLandingData from "./updateLandingData";

export default function updateSection( section: ILandingSection, historyStep: IHistoryStep | null = null, isForce?: boolean, callBack?: () => void ): boolean {
    const currentLanding: ILanding  = useLandingStore.getState().currentLanding
    const updateLanding             = useLandingStore.getState().updateLanding
    let is = false 
    const newVal = {
        ...currentLanding,
        sections: currentLanding.sections.map(sc => {
            if(sc.id === section.id) {
                is = true
                return section
            }
            return sc
        }) 
    }
    if(!!historyStep) {
        updateHistory( historyStep, newVal, isForce, callBack )
    } 
    else {
        updateLanding( { currentLanding : newVal } )
        useLandingStore.setState({  
            needUpdate: true,  
        })
        if( isForce ) {
            updateLandingData( callBack )
        }
    } 
    return is
}